import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CONTACT_SUPPORT_TEL, CONTACT_SUPPORT_TEL_2, USING_TCM_LINKS } from 'shared/constants';
import { Link } from 'react-router-dom';

import './Help.scss';

const Help = (props) => {
  const { t } = useTranslation();
  return (
    <div className="col">
      <div className="help-container">
        <h4> {t('help.title')} </h4>
        <div className="box">
          <p> {t('help.viewResourcesMessage')} </p>
          <a target="_blank" href={USING_TCM_LINKS.resources} className="btn btn-small btn-primary">
            {t('help.viewResourcesLabel')}
          </a>
        </div>
        <div className="box">
          <p> {t('help.searchMessage')} </p>
          <a
            target="_blank"
            href="https://content.act.org/act_national/home"
            className="btn btn-small btn-primary">
            {t('help.searchLabel')}
          </a>
        </div>
        <div className="box">
          <p> {t('help.contactUsMessage')} </p>
          <div className="contact-support">
            <p className="text-pacific-blue">
              <a href={`tel:${CONTACT_SUPPORT_TEL}`}>
                <i className="material-icons">phone</i>
                <span>{t('profile.contactSupport.callUsLabel')} </span>
                <span className="support-number">{CONTACT_SUPPORT_TEL}</span>
              </a>
            </p>

            <p className="text-pacific-blue">
              <Link href="/email-us" to="/email-us">
                <i className="material-icons">email</i>
                <span>{t('profile.contactSupport.emailUsLabel')}</span>
              </Link>
            </p>

            <div className="call-us navy-color">
              {t('profile.contactSupport.callUsLabel')} <span>{CONTACT_SUPPORT_TEL_2}</span>
            </div>
            <div className="manually-dialed navy-color">
              {t('profile.contactSupport.manuallyDialedMessage')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;
